/*
 * Stallergenes Greer — Einblend-Animation
 *
 * Der abgenommene Prototyp blendet Abschnitte beim Scrollen sanft ein:
 * .reveal startet unsichtbar, ein Beobachter setzt .in sobald das Element
 * in den Blick kommt. Ohne dieses Skript bliebe alles mit .reveal dauerhaft
 * unsichtbar - genau das ist beim ersten Übertrag passiert.
 *
 * Zwei Sicherheitsnetze, die der Prototyp nicht hatte:
 *  - Wer "Bewegung reduzieren" eingestellt hat, sieht sofort alles.
 *  - Fehlt IntersectionObserver, wird ebenfalls sofort eingeblendet.
 *    Ein Inhalt darf nie unsichtbar bleiben, nur weil Technik fehlt.
 */
(function () {
  function alleZeigen() {
    document.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('in');
    });
  }

  function start() {
    var elemente = document.querySelectorAll('.reveal:not(.in)');
    if (!elemente.length) return;

    var sparsam =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (sparsam || !('IntersectionObserver' in window)) {
      alleZeigen();
      return;
    }

    var beobachter = new IntersectionObserver(
      function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            beobachter.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    elemente.forEach(function (el) {
      beobachter.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  // Im Theme-Editor werden Sections neu geladen - dann erneut anwenden.
  document.addEventListener('shopify:section:load', start);
})();
